import { Typography, Layout, Modal, Button, Checkbox } from "antd";
import { useState } from "react";

function AppFooter() {
  const [modal, setModal] = useState({isOpen: false, title: "", content: ""});
  const showModal = (title) => {
    setModal({...modal, isOpen: true, title});
  };
  const handleOk = () => {
    setModal({...modal, isOpen: false});
  };
  const handleCancel = () => {
    setModal({...modal, isOpen: false});
  }
  return (
    <Layout.Footer className="AppFooter">
      <Button type="link" onClick={() => showModal("Privacy Policy")}>Privacy Policy</Button>
      <Button type="link" onClick={() => showModal("Terms of Use")}>Terms of Use</Button>
      <Modal
        open={modal.isOpen}
        title={<Typography.Title level={3} style={{margin:0}}>{modal.title}</Typography.Title>}
        onOk={handleOk}
        onCancel={handleCancel}
        style={{top: 50}}
      >
        <Typography.Paragraph style={{overflowY: "scroll", maxHeight: 400, boxShadow: "1px 1px 5px #b2b2b2", padding: 10, textAlign: "justify", borderRadius: 5}}>
          {"lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua".repeat(30)}
        </Typography.Paragraph>
        <Checkbox>Accecpt all</Checkbox>
      </Modal>
    </Layout.Footer>
  );
}
export default AppFooter;
